import "./About.css";
import { useT } from "@/i18n/context";
import { company } from "@/data/company";

export function About() {
  const t = useT();
  return (
    <section id="about" className="section about">
      <div className="container">
        <div className="about__inner" data-reveal="">
          <div className="about__content">
            <h2 className="section__heading">{t.about.heading}</h2>
            <p className="about__body">{t.about.body}</p>
          </div>
          <aside className="about__aside">
            <div className="about__stat">
              <span className="about__stat-year">{company.foundedYear}</span>
              <span className="about__stat-label">{t.about.foundedLabel}</span>
            </div>
            <span className="about__badge">{t.about.badge}</span>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default About;
